// Browser cannot call auth.admin.deleteUser directly — must go through Worker with service_role.
// Guide: https://supabase.com/docs/guides/auth/managing-user-data#deleting-users
// Deleting via auth.admin.deleteUser removes auth.users row, cascades to auth.sessions and profiles (on delete cascade), invalidates refresh tokens.
// Note: already-issued access tokens remain valid until exp — mitigations:
// (a) keep access token expiry short (e.g., 10m in Supabase Dashboard > Auth > JWT expiry)
// (b) for sensitive ops validate session_id claim against auth.sessions table

export async function requestAccountDeletion(accessToken: string): Promise<void> {
	const base = import.meta.env.VITE_AI_API_URL || "";
	const res = await fetch(`${base}/account/delete`, {
		method: "POST",
		headers: { Authorization: `Bearer ${accessToken}` },
	});
	if (!res.ok) {
		const body = (await res.json().catch(() => ({}))) as { error?: string };
		throw new Error(body.error || "Xóa tài khoản thất bại.");
	}
}
